import { styled, Switch } from "@mui/material";

export const IOSSwitch = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,

  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",

    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",

      "& + .MuiSwitch-track": {
        backgroundColor: "#2563EB", // brandBlue-500
        opacity: 1,
        border: 0,
      },
    },

    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.4,
    },
  },

  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
    backgroundColor: "#fff",
  },

  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "rgba(255,255,255,0.35)",
    backdropFilter: "blur(10px)",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 300,
    }),
  },
}));
